import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootState';
import styled from 'styled-components/macro';
import * as Actions from '../../../store/actions';
import { App } from '../../../app';
import Button from '../../shared/Button';

export interface ArchiveZipListProps {
}

export default function ArchiveZipList(props: ArchiveZipListProps): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);

    const list: string[] = state.archiveCurrentStatus?.ZipFiles ?? [];

    const onZipFileClick = (evt: React.MouseEvent, zipFileName: string): void => {
        evt.preventDefault();
        App.telemetry.postBusinessEvent("downloadarchivezip-clicked", { filename: zipFileName });
        Actions.downloadArchiveZip(zipFileName);
    }

    return list && list.length !== 0 &&
        <Wrapper>
            {list.map((zipFileName, i) => (
                <Button key={i} buttonType="link" size="compact" className="filename" onClick={(evt) => onZipFileClick(evt, zipFileName)}>{zipFileName}</Button>
            ))}
        </Wrapper>
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    .filename {
        font-weight: normal;
        font-size: var(--font-size-default);
        text-align: left;
    }
`;